import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Modal, Row, Switch } from "antd";

import moment from "moment";

import { dsrService } from "./../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
	UIUpload,
} from "./../../components";


const config = {
	externalName: "paciente",
};

class Show extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onClose: PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			uuid: 0,
			item: {},
			general_key: null
		};
	}

	onOpen = (uuid, key) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
			item: {},
			general_key: key,
		});

		dsrService.show({ uuid })
			.then((response) => {
				let item = response.data.data;

				this.setState({
					isLoading: false,
					item: item,
				}, () => {
					// Upload
					if (item.avatar) {
						this.upload.setFiles([
							{
								uuid: item.uuid,
								url: item.avatar,
								type: 'image/jpeg',
							}
						]);
					}

					// Load options
					this.tabUsers && this.tabUsers.init(item);
					this.tabAdresses && this.tabAdresses.init(item);
					this.tabContacts && this.tabContacts.init(item);
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	resetFields = () => {
		this.setState({
			item: {},
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	render() {
		const { visible } = this.props;
		const { uuid, isLoading, item } = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				icon={<i className="fal fa-calendar-week" />}
				title="Visualizar DSR"
				subtitle="Consulte as informações do grupo de Descanso Semanal Remunerado.">
				<Form layout="vertical">
					<UIFormSection
						icon={<i className="fal fa-clipboard-list" />}
						title="Informações gerais"
					>
						<Row gutter={16}>
							<Col xs={24} md={24}>
								<Form.Item label="Nome">
									{item.nome ?? "-"}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Limite de horas falta">
									{item.horas_falta_limite ?? "-"}
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item label="Valor DSR">
									{item.horas_dsr ?? "-"}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} sm={12}>
								<Form.Item label="Criação">
									{moment(item.created_at).calendar() ?? "-"}
								</Form.Item>
							</Col>
							<Col xs={24} sm={12}>
								<Form.Item label="Ativo">
									<Switch disabled checked={item.ativo == 1 ? true : false} />
								</Form.Item>
							</Col>
						</Row>
					</UIFormSection>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
